import { AxiosService } from '@/shared/utils'
import { AxiosRequestConfig } from 'axios'
import { ScreeningReport } from '@/shared/types/screeningReport.type'
import { UploadRawFile } from 'element-plus'
import { SendReportToTelegramBot } from '@/shared/types'

class ScreeningReportApi
  extends AxiosService
  implements SendReportToTelegramBot
{
  constructor(config?: AxiosRequestConfig) {
    super(config)
  }

  public getReports(patientId: number) {
    return this.axiosCall({
      method: 'get',
      url: '/api/web/admin/screening',
      params: {
        patient_id: patientId,
      },
    })
  }

  public getReport(reportId: number) {
    return this.axiosCall({
      method: 'get',
      url: `/api/web/admin/screening/${reportId}`,
    })
  }

  public saveReport(patientId: number, report: ScreeningReport) {
    const { examination, modifiedBleedingIndex } = report
    return this.axiosCall({
      method: 'post',
      url: '/api/web/admin/screening',
      data: {
        patient_id: patientId,
        date_at: new Date(),
        examination: examination,
        modified_bleeding_index: modifiedBleedingIndex,
      },
    })
  }

  public updateReport(reportId: number, report: ScreeningReport) {
    const { examination, modifiedBleedingIndex, reCleaning } = report
    return this.axiosCall({
      method: 'patch',
      url: `/api/web/admin/screening/${reportId}`,
      data: {
        examination: examination,
        modified_bleeding_index: modifiedBleedingIndex,
        re_cleaning: reCleaning,
      },
    })
  }

  public removeReport(reportId: number) {
    return this.axiosCall({
      method: 'delete',
      url: `/api/web/admin/screening/${reportId}`,
    })
  }

  public addComment(reportId: number, comment: string, files: UploadRawFile[]) {
    const formData = new FormData()

    files.forEach((file) => {
      formData.append('files[]', file)
    })
    formData.append('text', comment)

    return this.axiosCall({
      method: 'post',
      url: `/api/web/admin/screening/${reportId}/comment`,
      data: formData,
    })
  }

  public removeComment(commentId: number) {
    return this.axiosCall({
      method: 'delete',
      url: `/api/web/admin/screening/comment/${commentId}`,
    })
  }

  public sendEmail(reportId: number, sendCommentFiles: boolean) {
    const data = new FormData()
    data.append('report_id', reportId.toString())
    data.append('send_comment_files', sendCommentFiles ? 'true' : 'false')

    return this.axiosCall({
      method: 'post',
      url: '/api/web/admin/screening/send-email',
      data,
    })
  }

  public sendReportToTelegramBot(reportId: number) {
    return this.axiosCall({
      method: 'post',
      url: `/api/web/admin/screening/telegram/${reportId}`,
    })
  }

  public downloadPdf(reportId: number) {
    return this.axiosCall({
      method: 'get',
      url: `/api/web/admin/screening/download-from-service/${reportId}`,
      responseType: 'blob',
    })
  }
}

export const screeningReportApi = new ScreeningReportApi({
  baseURL:
    process.env.NODE_ENV === 'production' ? process.env.VUE_APP_BASE_URI : '',
  withCredentials: true,
})
